import { useContext } from 'react';

import colors from '@atom/styles/colors';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import {
  CLOSED_STATUS_ID,
  isWorkOrderCompletedOrAbove,
} from '@atom/utilities/workOrderStatusUtilities';

import BulkContext, { Tab } from '../../../BulkContext';
import Field from '../Field';

import DateField from './DateField';
import UserSelectField from './UserSelectField';
import WorkStatus from './WorkStatus';

import classes from '../body.module.css';

export interface Props {
  tab: Tab;
}

const GeneralBody = ({ tab }: Props) => {
  const { assets, invalidFields, workOrder, workTemplateType } =
    useContext(BulkContext);

  const invalid = invalidFields?.general || new Set();

  const sameAssetType =
    assets.length > 0 &&
    assets.every(asset => asset.assetType === assets[0].assetType);

  const inventoryType = sameAssetType ? assets[0].assetType : 'Multiple';
  const estimatedCost = numberToLocaleString(workTemplateType?.estimatedCost);

  return (
    <div className={classes.body}>
      <div className={classes.bodyHeader}>
        <div className={classes.bodyHeaderTitle}>{tab.label}</div>
        <div className={classes.bodyHeaderMetaContainer}>
          <div className={classes.bodyHeaderMetaField}>
            Inventory Name: Multiple
          </div>
          <div className={classes.bodyHeaderMetaField}>
            Inventory Type: {inventoryType}
          </div>
          <div className={classes.bodyHeaderMetaField}>
            Estimated Cost: {estimatedCost}
          </div>
        </div>
      </div>
      <div className={classes.bodyContent}>
        <Field
          icon="lock"
          iconColor={colors.utility.activeBlue}
          label="Work Template"
          input={<div>{workTemplateType?.name}</div>}
        />
        <div className={classes.bodyContentTwoColumn}>
          <Field
            icon="event"
            input={<DateField label="Due Date" name="dueDate" />}
          />
        </div>
        <Field
          icon="arrow_drop_down_circle"
          label="Work Status"
          input={<WorkStatus />}
        />
        {isWorkOrderCompletedOrAbove(workOrder.statusId) && (
          <div className={classes.bodyContentTwoColumn}>
            <Field
              input={
                <DateField
                  label="* Completed Date"
                  name="completionDate"
                  error={invalid.has('completionDate')}
                  required
                />
              }
            />
            <Field
              input={
                <UserSelectField
                  label="* Completed By"
                  name="completedBy"
                  error={invalid.has('completedBy')}
                />
              }
            />
          </div>
        )}
        {workOrder.statusId === CLOSED_STATUS_ID && (
          <div className={classes.bodyContentTwoColumn}>
            <Field
              input={
                <DateField
                  label="* Closed Date"
                  name="closedDate"
                  error={invalid.has('closedDate')}
                  required
                />
              }
            />
            <Field
              input={
                <UserSelectField
                  label="* Closed By"
                  name="closedBy"
                  error={invalid.has('closedBy')}
                />
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GeneralBody;
